import $ from 'jquery'
import { formatMoney } from './helpers'
import axios from 'axios'
import { updateCart } from './ajax-cart'

// Run on page load also
updateTotal()

$('.complete-the-look-checkbox').on('change', function () {
  const isChecked = $(this).prop('checked')
  const root = $(this).parents('.complete-the-look-item')
  const selectedClass = 'complete-the-look-item--selected'

  isChecked ? root.addClass(selectedClass) : root.removeClass(selectedClass)

  updateTotal()
})

$('.complete-the-look-select').on('change', function () {
  const root = $(this).parents('.complete-the-look-item')
  const variantId = Number($(this).val())
  const productJsonText = root.attr('data-complete-product')
  const productJson = JSON.parse(productJsonText)
  const selectedVariant = productJson.variants.find((v) => v.id === variantId)
  const newPrice = formatMoney(selectedVariant.price).replace('.00', '')

  root.find('img').attr('src', selectedVariant.featured_image.src)
  root.find('.complete-the-look-price').text(newPrice)
  root.find('.complete-the-look-price').attr('data-price', selectedVariant.price)

  updateTotal()
})

function updateTotal() {
  let total = 0

  $('.complete-the-look-item--selected .complete-the-look-price').each(function () {
    const price = Number($(this).attr('data-price'))
    total += price
  })

  const priceText = formatMoney(total).replace('.00', '')

  $('.complete-the-look-header-price span').text(priceText)
}

$('.complete-the-look-header-add button').on('click', async function (e) {
  e.preventDefault()

  // Build ajax data
  const items = []

  document.querySelectorAll('.complete-the-look-item--selected').forEach((itemRoot) => {
    items.push({ id: itemRoot.querySelector('select').value })
  })

  // post it
  await axios.post('/cart/add.js', { items })

  // Refresh cart
  updateCart()
})
